import { css, unsafeCSS } from 'lit-element';
import {
  g55, g300, gm55, n50, n55, n300, n400, n670, white,
} from '@aab/sc-styles-colors';

const cellStyles = css`
    :host {
        font-family: Roboto;
        display: block;
        width: 42px;
        height: 42px;
      }

      .day {
        height: 40px;
        width: 40px;
        margin-right: 2px;
        margin-top: 2px;
        color: ${unsafeCSS(n670)};
      }

      .day.pastDate {
        color: ${unsafeCSS(n400)};
      }

      .day:not(.disabled):hover {
        background: ${unsafeCSS(g55)} !important;
        cursor: pointer;
      }

      .day.currentDate {
        font-weight: 500;
        background-color: ${unsafeCSS(n50)};
        color: ${unsafeCSS(n670)};
      }

      .day.currentDate::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 31px;
        left: 18px;
        width: 4px;
        height: 4px;
        background-color: ${unsafeCSS(g300)};
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        border-radius: 2px;
      }

      .day.currentDate.selected::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 31px;
        left: 18px;
        width: 4px;
        height: 4px;
        background-color: ${unsafeCSS(white)};
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        border-radius: 2px;
      }

      .day.selected {
        width: 42px !important;
        margin-right: 0px !important;
        background: ${unsafeCSS(g300)} !important;
        color: ${unsafeCSS(white)};
      }

      .day.hovered {
        width: 42px !important;
        margin-right: 0px !important;
        border-radius: 0px !important;
        background: ${unsafeCSS(gm55)} !important;
        color: ${unsafeCSS(n670)} !important;
      }

      .day.disabled {
        background: ${unsafeCSS(n55)} !important;
        color: ${unsafeCSS(n300)} !important;
        width: 40px !important;
        margin-right: 2px !important;
      }
`;

export default cellStyles;
